var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDeckIcon = function SvgDeckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.17 13.142c.174.26.415.426.7.474l4.313.757a.88.88 0 0 0 .985.615l7.115-1.278a.853.853 0 0 0 .57-.402.934.934 0 0 0 .13-.687L13.146 1.852c-.022-.142-.088-.26-.154-.379 0-.023-.022-.023-.022-.023-.175-.213-.415-.355-.7-.355-.044 0-.11 0-.153.023l-3.744.687-4.379-.781c-.065 0-.13-.024-.175-.024-.503 0-.963.379-1.05.923l-1.752 10.39c-.044.285 0 .593.153.83Z",
    stroke: "#5D5C5C",
    strokeWidth: 0.2,
    fill: "#5D5C5C"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ECFEEE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.568 12.716a.437.437 0 0 1-.066.332.425.425 0 0 1-.307.213l-7.093 1.301h-.087a.44.44 0 0 1-.438-.378L4.737 3.509l3.066 5.633c.044.071.11.118.197.118.087 0 .153-.07.175-.142l1.751-4.686.964 1.965c.043.07.11.118.197.118.087 0 .153-.071.175-.142l1.489-4.024 1.817 10.367Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.181 1.568a.498.498 0 0 1 .373.095l-1.49 4.07-.962-1.964a.227.227 0 0 0-.198-.118c-.087 0-.153.07-.175.142l-1.751 4.71-3.043-5.562a1.44 1.44 0 0 1 .175-.071l7.071-1.302Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1.432 12.408 1.751-10.39a.668.668 0 0 1 .745-.545l3.152.568-2.058.38a.884.884 0 0 0-.503.307l-.022.024c-.022.023-.022.047-.044.047-.131.19-.175.45-.131.686L6.117 13.9l-4.138-.734c-.175-.024-.328-.142-.437-.284a.615.615 0 0 1-.11-.474Z",
    fill: "#ECFEEE"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#5D5C5C",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    d: "m6.802 11.059 6.348-1.42M7.02 12.479l6.349-1.42"
  }))));
};
export default SvgDeckIcon;